import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  // Добавить товар в корзину (или увеличить количество)
  const addToCart = (product) => {
    setCart((prevCart) => {
      const existing = prevCart.find(
        (item) => item.name === product.name && item.weight === product.weight
      );
      if (existing) {
        return prevCart.map((item) =>
          item.name === product.name && item.weight === product.weight
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  };

  // Изменить количество товара
  const updateQuantity = (product, quantity) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.name === product.name && item.weight === product.weight
          ? { ...item, quantity }
          : item
      )
    );
  };

  // Удалить товар
  const removeFromCart = (product) => {
    setCart((prevCart) =>
      prevCart.filter(
        (item) => !(item.name === product.name && item.weight === product.weight)
      )
    );
  };

  // Очистить корзину
  const clearCart = () => setCart([]);

  return (
    <CartContext.Provider value={{ cart, addToCart, updateQuantity, removeFromCart, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
} 